import Highcharts from 'highcharts';
import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';
import 'highcharts/highcharts-more';
import 'highcharts/modules/solid-gauge';
import 'highcharts/modules/map';
import 'highcharts/modules/series-on-point';
import 'highcharts/modules/exporting';

import mapBudget from './map-budget.js'
import mapRanking from './map-ranking.js'
import chartFinesStructure from './chart-fines-structure.js'
import globalOptions from './options.js'
import chartGuards from './chart-guards.js'
import { chartMandaty, chartSelfinancing, chartPriceOfFine } from './chart-mandaty.js'
import gridBudget from './grid-budget.js'
import chartPouczenia from './chart-pouczenia.js'
import gridResearch from './grid-research.js'
import initializeFixedMenu from './menu.js'
import initializeSectionLinks from './section-links.js'
import initializeCollapsible from './collapsibe.js'
import initializeMetricsToggle from './metrics-toggle.js'
import chartSalaries from './chart-salaries.js'
import chartVacancies from './chart-vacancies.js'
import chartStructure from './chart-structure.js'
import chartClamps from './chart-clamps.js'
import { chartTowing, chartTowing100k } from './chart-towing.js'
import chartWrecks from './chart-wrecks.js'
import chartPolice from './chart-police.js'
import chartFire from './chart-fire.js'
import chartResponseTime from './chart-response-time.js'
import chartClosureRate from './chart-closure-rate.js'
import gridEfficiency from './chart-efektywnosc.js'
import { chartSPPRevenue, chartSPPFinesShare, chartSPPAbsolute } from './chart-spp.js'
import gridMetodologia from './grid-metodologia.js'

Highcharts.setOptions(globalOptions);
Grid.setOptions(globalOptions)


// Inicjalizacja wykresów po załadowaniu DOM
document.addEventListener('DOMContentLoaded', async function () {
    initializeCollapsible();
    initializeMetricsToggle();
    initializeSectionLinks();
    // Add small delay to ensure menu is rendered
    setTimeout(() => {
        initializeFixedMenu();
    }, 100);

    chartGuards('bar-chart-staff')
    chartMandaty('bar-chart-fines-per-guard')
    chartSelfinancing('bar-chart-self-financing')
    chartPriceOfFine('bar-chart-price-of-fine')
    gridBudget('table-budget')
    chartPouczenia('bar-chart-pouczenia')
    gridResearch('table-research')
    await mapRanking('map-ranking')
    await mapBudget('map-budgets')
    chartFinesStructure('chart-fines-structure')

    chartSalaries('bar-chart-salaries')
    chartVacancies('bar-chart-vacancies')
    chartStructure('bar-chart-structure')

    chartClamps('bar-chart-clamps')
    chartTowing('bar-chart-towing')
    chartTowing100k('bar-chart-towing100k')
    chartWrecks('bar-chart-wrecks')
    chartPolice('bar-chart-police')
    chartFire('chart-fire-summary')
    chartResponseTime('bar-chart-response-time')
    chartClosureRate('bar-chart-closure-rate')
    gridEfficiency('table-efficiency')
    chartSPPRevenue('chart-spp-revenue')
    chartSPPFinesShare('chart-spp-fines-share')
    chartSPPAbsolute('chart-spp-absolute')
    gridMetodologia('table-metodologia')
});
